import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeInstallPrompt } from './pwaInstall';

// Debug environment variables
console.log('VITE_FIREBASE_API_KEY:', import.meta.env.VITE_FIREBASE_API_KEY ? '[SET]' : '[MISSING]');

// Make sure the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root');

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    );
  } else {
    console.error("Root element with id 'root' not found!");
  }
});

// Initialize PWA install prompt (SW registration handled by static sw.js in public/)
initializeInstallPrompt((ready: boolean) => {
  if (ready) {
    localStorage.setItem('pwaInstallReady', 'true');
  }
});